// extracted by mini-css-extract-plugin
export var notificationHost = "_do-0";